<template>
  <NuxtLayout :name="layout">
    <div class="error__container wd-flex wd-items-center wd-justify-center">
      <div class="page__content">
        <div>
          <h1 :class="errorUiContext.titleClass">{{ errorUiContext.title }}</h1>

          <h3 v-if="errorUiContext.is404" :class="errorUiContext.subtitleClass">
            {{ errorUiContext.subtitle }}
          </h3>
        </div>

        <template v-if="errorUiContext.isButtonShow">
          <v-btn v-if="!errorUiContext.isFromTng" :to="localePath('/')" class="back-home-btn elevation-0" height="40" color="orange50" size="large">
            <span class="wd-text-white">{{ $t('page_404_back_to_home') }}</span>
          </v-btn>
          <v-btn v-else class="back-home-btn elevation-0" min-width="198" color="orange50" size="large" @click="tngNavigateBack">
            {{ $t('all_back') }}
          </v-btn>
        </template>
      </div>

      <div class="page__image">
        <v-img :width="funbookV2ImageWidth" src="@/assets/images/funnow/404.svg?url" />
      </div>
    </div>
  </NuxtLayout>
</template>

<script>
import { usePlatformStore } from '@/store-pinia/platform'

const OTHER_ERROR = 'An error occurred'

export default defineNuxtComponent({
  props: {
    error: { type: Object, default: null },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()
    const { $store: store, $i18n } = nuxtApp
    const route = useRoute()
    const localePath = useLocalePath()

    const platformStore = usePlatformStore()
    const { isFunBookV2 } = storeToRefs(platformStore)

    const layout = computed(() => (isFunBookV2.value ? 'funbook-v2-error-layout' : 'default'))

    const fromTngMiniProgram = computed(() => store.getters.fromTngMiniProgram)
    const is404 = computed(() => props.error?.statusCode === 404)

    const errorUiContext = computed(() => ({
      title: is404.value ? (isFunBookV2.value ? $i18n.t('page_404_title_funbook') : $i18n.t('page_404_title')) : OTHER_ERROR,
      subtitle: isFunBookV2.value ? $i18n.t('page_404_content_funbook') : $i18n.t('page_404_content'),
      titleClass: is404.value ? 'wd-mb-2' : !isFunBookV2.value ? 'wd-mb-6' : '',
      subtitleClass: isFunBookV2.value ? 'headlin font-weight-regular' : 'headlin font-weight-regular wd-mb-6',
      is404: is404.value,
      isButtonShow: !isFunBookV2.value,
      isFromTng: fromTngMiniProgram.value,
    }))

    // SPA mode error handler for locale fallback flow
    const currentRoute = nuxtApp.$router.currentRoute
    if (import.meta.client && nuxtApp.$localeRoute(currentRoute.value.path)?.matched?.length && props.error.message.includes('Page not found:')) {
      clearError().catch(() => showError(props.error))
    }

    onBeforeMount(() => {
      initialApp()
    })

    async function initialApp() {
      await store.dispatch('region/getAllRegion')
    }

    return {
      isFunBookV2,
      errorUiContext,
      layout,
      localePath,
    }
  },
  data() {
    return {
      pageNotFound: '404 Not Found',
      otherError: OTHER_ERROR,
    }
  },
  head() {
    const title = this.error?.statusCode === 404 ? this.pageNotFound : this.otherError
    return {
      title,
      script: [{ hid: 'tng', src: 'https://appx/web-view.min.js' }],
    }
  },
  computed: {
    funbookV2ImageWidth() {
      return this.$vuetify.display.mdAndUp ? 320 : 240
    },
  },
  methods: {
    tngNavigateBack() {
      const my = global.my
      my.navigateBack()
    },
  },
})
</script>

<style lang="scss" scoped>
.error__container {
  height: 100%;

  .page__content {
    margin-right: 72px;
  }

  h1 {
    font-size: 36px;
    line-height: 44px;
    font-weight: 400;
  }
  h3 {
    font-size: 20px;
    line-height: 28px;
  }

  .back-home-btn {
    font-size: 17px;
    padding: 8px 16px;
  }

  @include xs {
    flex-direction: column-reverse;
    padding: 60px 0px;

    .page__content {
      margin-right: 0;
      text-align: center;
    }

    h1 {
      font-size: 24px;
      line-height: 32px;
    }
    h3 {
      font-size: 15px;
      line-height: 22px;
    }

    .page__image {
      margin-bottom: 24px;
    }
  }
}
</style>
